"use client"

import type { CategoryExpressProps } from "@/types/types"
import { ComponentConfig } from "@measured/puck"
import { twMerge } from "tailwind-merge"
import { generateResponsiveCSS } from "../../../lib/helper"
import { CategoryExpressContent } from "./components/CategoryExpressContent"
import { useCategoryExpress } from "./hooks/useCategoryExpress"

export const RenderConfig: ComponentConfig<CategoryExpressProps> = {
  render: ({
    title,
    items,
    className,
    styles,
    responsiveType,
    id: componentId,
  }: CategoryExpressProps & { id?: string }) => {
    const { id } = useCategoryExpress({
      items,
      componentId,
    })

    const mergedStyles = styles || {}
    const responsiveCSS = generateResponsiveCSS(id, mergedStyles, responsiveType || "mobileFirst")

    return (
      <>
        {responsiveCSS}
        <CategoryExpressContent id={id} title={title} items={items} className={twMerge(className)} />
      </>
    )
  },
}
